import { Component } from '@angular/core';

@Component({
  selector: 'df-page-list-loader',
  templateUrl: './page-list-loader.component.html',
  styleUrls: ['./page-list-loader.component.scss'],
})
export class PageListLoaderComponent {}
